import { useState, useEffect, Suspense } from "react";
import { useSelector, useDispatch } from "react-redux";
import { login } from "./redux/logger/logActions";
import Axios from "axios";
import {
  BrowserRouter,
  Route,
  Routes,
  NavLink,
  Navigate,
} from "react-router-dom";
import Navbar from "./layouts/Navbar";
import LoginPage from "./components/LoginPage";
import Search from "./components/Search";

// import AddBook from "./pages/AddApplication/AddApplication";
import { AddBookContextProvider } from "./context/AddApplicationContext";
import VerifyEmail from "./pages/auth/VerifyEmail";
import ResetPassword from "./pages/auth/ResetPassword";
// import Applications from "./pages/AddApplication/Applications";
import Dashboard from "./pages/profiles/Dashboard";
// import BookList from "./pages/admin/Books";
import OauthLogin from "./pages/auth/OauthLogin";
import Home from "./pages/Home";
import Loading from "./components/Loading";
import { basePath } from "./utility";
function App() {
  const [toggleSideBar, setToggleSidebar] = useState(false);
  const [openLoginDialog, setOpenLoginDialog] = useState(false);
  const [logType, setLogType] = useState(null);
  const [currentTab, setCurrentTab] = useState("My Applications");
  const dispatch = useDispatch();

  Axios.defaults.withCredentials = true;

  const getUserDetails = async () => {
    let user = null;
    let userId = null;
    let userApplications = [];

    try {
      const result = await Axios.get(`${basePath.url}auth/login`);
      userId = result.data.user.userId;

      user = result.data.user;

      const getUserApplications = await Axios.get(
        `${basePath.url}application/my-applications/${userId}`
      );

      // console.log(getUserApplications);
      userApplications = [...getUserApplications.data.data];

      user.userApplications = userApplications;

      dispatch(login(user));
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    getUserDetails();
  }, []);

  const handleToggle = () => {
    setToggleSidebar((prev) => {
      return !prev;
    });
  };

  return (
    <>
      <BrowserRouter>
        <div
          style={{
            width: "100%",
            minHeight: "100vh",
            backgroundColor: "transparent",
            margin: 0,
            padding: 0,
          }}
        >
          <Navbar
            toggleSideBar={toggleSideBar}
            handleToggle={handleToggle}
            openLoginDialog={openLoginDialog}
            setOpenLoginDialog={setOpenLoginDialog}
            logType={logType}
            setLogType={setLogType}
            setCurrentTab={setCurrentTab}
          />

          <LoginPage
            openLoginDialog={openLoginDialog}
            setOpenLoginDialog={setOpenLoginDialog}
            logType={logType}
            setLogType={setLogType}
          />
          <div className="wrapper" style={{ backgroundColor: "transparent" }}>
            <div
              className="main-outer"
              style={{ backgroundColor: "transparent" }}
            >
              <Routes>
                <Route path="/" element={<Home />} />
                {/* <Route
                  path="/books/book-details/:id"
                  element={<BookPreview />}
                /> */}

                {/* <Route
                  path="/admin"
                  element={
                    <Suspense fallback={<Loading />}>
                      <BookList />
                    </Suspense>
                  }
                /> */}
                <Route path="/verify-email/:token" element={<VerifyEmail />} />
                <Route
                  path="/reset_password/:token"
                  element={<ResetPassword />}
                />
                <Route
                  path="/user-profile"
                  element={
                    <Suspense fallback={<Loading />}>
                      <Dashboard
                        currentTab={currentTab}
                        setCurrentTab={setCurrentTab}
                      />
                    </Suspense>
                  }
                />
                <Route path="/oauth" element={<OauthLogin />} />
                {/* <Route path="/s" element={<SearchBooks />} /> */}
                {/* <Route path="/verify-payment" element={<VerifyPayment />} /> */}
              </Routes>

              {/* <AddBookContextProvider>
              <AddBook />
            </AddBookContextProvider> */}
            </div>
          </div>

          <div className="footer"></div>
        </div>
      </BrowserRouter>
    </>
  );
}

export default App;
